import React from 'react';
import { DataContext } from '../../context/DataProvider';
import { useContext } from 'react';


const SuccessPayment = () => {
    const { successCode, orderId } = useContext(DataContext);
    // { successMessage, successCode, orderId, domainURL, domain }
    return (
        <div className="success-pay">
            <div className="container">
                <h2 className="mt-3 mb-3">
                    <b>Your Payment was successful</b>
                </h2>

                {successCode === 1 ? (
                    <>
                        <p>
                            Thank you for deciding to subscribe to{' '}
                            <a href={window.location.origin} style={{ color: '#1601b9', textDecoration: 'underline' }}>
                                {window.location.origin}
                            </a>. We very much appreciate this opportunity to provide you with tender opportunities information.
                            <br />
                            We will customize your query and activate your account within 24 hours. You will receive a mail when this has been done.
                        </p>
                        <p>
                            For your reference, please note your order number. Please provide this number when contacting us regarding your order.
                        </p>
                        <p>Your Order Number is: <b>{orderId}</b></p>
                    </>
                ) : (
                    <>
                        <p>
                            Thank you for deciding to subscribe to{' '}
                            <a href={window.location.origin} style={{ color: '#1601b9', textDecoration: 'underline' }}>
                            {window.location.origin}
                            </a>. We greatly appreciate this opportunity to provide you with tender opportunities information,
                            but due to one of the following reasons, your payment is not accepted:
                        </p>
                        <div className="deciding-point">
                            <span>Insufficient funds</span>
                            <span>Wrong expiry date</span>
                            <span>Delay in processing the transaction</span>
                            <span>Merchant has not tied for this type of card.</span>
                        </div>
                    </>
                )}
            </div>

            <a
                className=""
                href={window.location.origin}
                style={{ background: '#767676', padding: '7px 23px', color: '#fff', borderRadius: '30px' }}
            >
                Go to Home
            </a>
        </div>
    );
};

export default SuccessPayment;
